import React, { useEffect, useState } from 'react';
import './FeatureStyles.css';
import './ReportsInsightsFeature.css';

const ReportsInsightsAnimation = () => {
  const baseHeights = [85, 72, 90, 65, 78, 60, 55];
  const [barHeights, setBarHeights] = useState(baseHeights);

  useEffect(() => {
    const interval = setInterval(() => {
      const time = Date.now() / 1000;

      const newHeights = baseHeights.map((base, idx) => {
        // Each bar has unique speed and phase offset
        const speed = 1.2 + idx * 0.15;
        const phase = idx * 1.1;
        const amplitude = 18 + idx * 3;

        // Lively sine wave oscillation
        const offset = Math.sin(time * speed + phase) * amplitude;
        return Math.max(15, Math.min(98, base + offset));
      });

      setBarHeights(newHeights);
    }, 50); // Update every 50ms for smooth animation

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="feature-animation reports-clean">
      <div className="bar-chart-clean">
        {barHeights.map((height, idx) => (
          <div key={idx} className="bar-column">
            <div
              className="bar-clean"
              style={{ height: `${height}%` }}
            />
            <span className="bar-day">{['M', 'T', 'W', 'T', 'F', 'S', 'S'][idx]}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

const ReportsInsightsFeature = {
  icon: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    </svg>
  ),
  title: "Performance Reports & Insights",
  description: "Deliver on your promises. Track page load times, response times, and performance scores across your application. Share insightful reports with your customers to prove quality and build trust. AI-powered insights identify bottlenecks so you can fix issues before they become complaints.",
  animation: <ReportsInsightsAnimation />
};

export default ReportsInsightsFeature;
